import ServiceOrderApprovalReview from "./ServiceOrderApprovalReview";
import ServiceWorkflowWorkspace from "./ServiceWorkflowWorkspace";

export default function ServiceOrdersWorkspace(props) {
  if (props.approvalDocumentId != null || props.mode === "approvals") {
    return <ServiceOrderApprovalReview {...props} mode="approvals" />;
  }
  return <ServiceWorkflowWorkspace {...props} mode={props.mode === "requests" ? "requisitions" : props.mode || "requisitions"} />;
}
